// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"AppSidebar_sidebar__1X07f"};